export function buildAssistantViewModel({ chat, historyItems, blocks }) {
    return {
        uiOpen: Boolean(chat?.uiOpen),
        settingsOpen: Boolean(chat?.settingsOpen),
        busy: Boolean(chat?.busy),
        mode: chat?.mode || "st",
        dialect: chat?.dialect || "generic-st",
        plcProfileId: chat?.plcProfileId || chat?.dialect || "generic-st",
        plcProfileOptions: Array.isArray(chat?.plcProfileOptions) ? chat.plcProfileOptions : [],
        canEditPlcProfile: Boolean(chat?.canEditPlcProfile),
        activePlcProfileKind: chat?.activePlcProfileKind || "built-in",
        activePlcProfileBaseLabel: chat?.activePlcProfileBaseLabel || "",
        activePlcProfileSummary: chat?.activePlcProfileSummary || "",
        activePlcProfileMarkdown: chat?.activePlcProfileMarkdown || "",
        activePlcProfileRules: Array.isArray(chat?.activePlcProfileRules) ? chat.activePlcProfileRules : [],
        activePlcProfileWarnings: Array.isArray(chat?.activePlcProfileWarnings) ? chat.activePlcProfileWarnings : [],
        plcProfileEditorOpen: Boolean(chat?.plcProfileEditor?.open),
        plcProfileDraft: chat?.plcProfileEditor?.draft || null,
        plcProfileEditorError: chat?.plcProfileEditor?.error || "",
        plcProfileEditorHints: Array.isArray(chat?.plcProfileEditorHints) ? chat.plcProfileEditorHints : [],
        settingsSummary: chat?.settingsSummary || "",
        statusText: chat?.statusText || "",
        taskHistoryOpen: Boolean(chat?.taskHistoryOpen),
        historyLoading: Boolean(chat?.historyLoading),
        historyItems: Array.isArray(historyItems) ? historyItems : [],
        blocks: Array.isArray(blocks) ? blocks : [],
        inputPlaceholder: chat?.inputPlaceholder || "追加指示を入力",
        questionDraftInput: chat?.questionDraftInput || "",
        questionCardError: chat?.questionCardError || "",
        lastResult: chat?.lastResult || "",
        threadTitle: chat?.threadTitle || "新規チャット",
        skillCount: chat?.skillCount || 0
    };
}
